import {
  ItemsViewLayout,
  layouts,
} from '@app/components/items-view-layout-switch/ItemsViewLayoutSwitch';
import { createAppStore } from '@app/core/stores';

/** Alias for shared layout type. List or grid with density (wide / normal / compact). */
export type FragmentViewMode = ItemsViewLayout;

interface FragmentsSettingsState {
  viewMode: ItemsViewLayout;
  setViewMode: (mode: ItemsViewLayout) => void;
}

/** Persisted subset (used for createAppStore second generic). */
type PersistedFragmentsSettingsState = Pick<FragmentsSettingsState, 'viewMode'>;

/**
 * Zustand store for fragments module settings.
 * Persists view mode (list or grid with density) across sessions.
 */
export const useFragmentsSettingsStore = createAppStore<
  FragmentsSettingsState,
  PersistedFragmentsSettingsState
>('FragmentsSettingsStore', {
  persist: {
    name: 'app.fragmentsSettings',
    version: 2,
    migrate: (persistedState: unknown, _version: number) => {
      const state = persistedState as { viewMode?: string };
      const viewMode = state?.viewMode ?? 'gridNormal';
      const validViewMode = layouts.includes(viewMode as ItemsViewLayout)
        ? (viewMode as ItemsViewLayout)
        : 'gridNormal';
      return {
        ...state,
        viewMode: validViewMode,
      } as FragmentsSettingsState;
    },
    partialize: (state) => ({
      viewMode: state.viewMode,
    }),
  },
})((set) => ({
  viewMode: 'gridNormal',

  setViewMode: (mode) => {
    set({ viewMode: mode });
  },
}));
